.page {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 640px;
  margin: 0 auto;
}

.title {
  font-size: 28px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.hint {
  margin-top: -10px;
  font-size: 13px;
  color: var(--ink-3);
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}

.waiting {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heading {
  font-size: 17px;
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style: none;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
}

.item {
  padding: 12px 18px;
  border-top: 1.5px solid var(--ink);
  font-weight: 600;
}

.item:first-child {
  border-top: 0;
}
